var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.77615 18.8374C7.49311 17.4273 5.37081 15.7645 3.44807 13.8796C2.09069 12.5338 1.05404 10.8905 0.417345 9.07526C-0.720287 5.53523 0.603988 1.48948 4.30129 0.288397C6.2528 -0.324469 8.37523 0.0517545 10.0072 1.29983C11.6398 0.0531503 13.7616 -0.322951 15.7132 0.288397C19.4105 1.48948 20.7436 5.53523 19.606 9.07526C18.9745 10.8888 17.944 12.5319 16.5931 13.8796C14.6686 15.7625 12.5465 17.4251 10.265 18.8374L10.0161 19L9.77615 18.8374Z",
    fill: "#8E75FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0109 18.9996L9.77598 18.8371C7.49013 17.427 5.36487 15.7643 3.43902 13.8792C2.0752 12.5352 1.03238 10.8918 0.390519 9.07487C-0.738225 5.53483 0.58605 1.48908 4.28335 0.288001C6.23486 -0.324865 8.38528 0.0516467 10.0109 1.31018V18.9996Z",
    fill: "#8E75FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2304 6.99922C16.0296 6.98629 15.8425 6.8859 15.7131 6.72157C15.5836 6.55723 15.5232 6.3434 15.5459 6.13016C15.5677 5.4278 15.168 4.78851 14.5517 4.53977C14.1609 4.43309 13.9243 4.00987 14.022 3.59249C14.1148 3.18182 14.4993 2.92647 14.8858 3.0189C14.9346 3.027 14.9816 3.04468 15.0244 3.07105C16.2601 3.54658 17.0601 4.82641 16.9965 6.22576C16.9944 6.43785 16.9117 6.63998 16.7673 6.78581C16.6229 6.93164 16.4291 7.00866 16.2304 6.99922Z",
    fill: "#8E75FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.d05b214cae26a2bbac52a9bfd40c5c08.svg";
export { ForwardRef as ReactComponent };